const styles = {
  datetime: {
    margin: "15px 0"
  }
};

export {
  styles
}
